import { createAction, handleActions } from 'redux-actions';

const SET_EDIT_ELIGIBILITY_RESULT = 'SET_EDIT_ELIGIBILITY_RESULT';

export const setEditEligibilityResult = createAction(SET_EDIT_ELIGIBILITY_RESULT);

export const reducer = handleActions(
  new Map([
    [
      setEditEligibilityResult,
      (state, action) => action.payload
    ],
  ]),
  null
); 